// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ks-c";
export var backButton = "_ks-4";
export var backIcon = "_ks-5";
export var chevronShortcut = "_ks-6";
export var container = "_ks-1";
export var editor = "_ks-8";
export var editorWrapper = "_ks-7";
export var prefix = "_ks-2";
export var searchIcon = "_ks-3";
export var suffix = "_ks-9";
export var suffixContent = "_ks-a";
export var suffixText = "_ks-b";
export var wrapper = "_ks-0";